import {initCKEditor, insertAtSelection} from "../../../helpers/inputs/ckeditor/ckeditor";
import Axios from "axios";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";
import {createModal} from "../../../helpers/modal";
import createElement from "../../../helpers/createElement";
import Swal from "sweetalert2";

function initEmailVoeTemplateIndex() {
	const container = document.querySelector('#settings-email-voe-template');

	const previewModal = createModal({
		modalContainer: null,
	});

	const editorElement = container.querySelector('.editor');
	let editor;

	initCKEditor(editorElement).then(newEditor => {
		// Save editor reference
		editor = newEditor

		// Set editor value
		editor.setData(window['settings']['emailVoeTemplate']);

		// Remove loading overlay
		editorElement.parentElement.classList.remove('loading');
	});

	// Init buttons
	const saveButton = container.querySelector('.save-voe-email-template-button')
	saveButton.addEventListener('click', saveVoeEmailTemplate)

	const previewButton = container.querySelector('.preview-button')
	previewButton.addEventListener('click', previewEmail);

	const sendEmailButton = container.querySelector('.sent-test-button')
	sendEmailButton.addEventListener('click', sendTestEmail);

	// Init placeholders
	container.querySelectorAll('.placeholder-trigger').forEach(trigger => {
		trigger.addEventListener('click', () => {
			insertAtSelection(editor, trigger.dataset.placeholder);
		})
	});

	/**
	 * Methods
	 */
	function saveVoeEmailTemplate() {
		const data = editor.getData();

		loading();
		Axios.post(
			window['storeVoeTemplateUrl'],
			{
				template: data,
			}
		)
			.then(response => {
				handleAjaxSuccess(response, () => {
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function previewEmail() {
		loading();
		const data = editor.getData();

		Axios.post(
			window['previewVoeTemplateUrl'],
			{
				template: data,
			}
		)
			.then(response => {
				previewModal.replace(
					createElement(response.data.modal)
				);

				previewModal.display();
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function sendTestEmail() {
		Swal.fire({
			title: 'Enter Target Email Address',
			input: 'text',
			showCancelButton: true,
			inputValidator: (value) => {
				if (!value) {
					return 'Please type an email address'
				}
			}
		}).then(result => {
			if (result.value) {
				loading();
				const data = editor.getData();

				Axios.post(
					window['testVoeTemplateUrl'],
					{
						template: data,
						email: result.value,
					}
				)
					.then(response => {
						handleAjaxSuccess(response, () => {
						})
					})
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})

	}

}


export {initEmailVoeTemplateIndex}
